export const twoFactorFunctions = {
  methods: {
    headers2FA(token) {
      return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
    },

    async request2FA() {
      const accountId = this.$auth.getProfile().id;
      const authToken = this.$auth.accessToken;
      const response = await this.axios.post(
        process.env.VUE_APP_LAMBDA_GET_TOKEN,
        { accountId },
        {
          headers: this.headers2FA(authToken),
        },
      );

      if (typeof response.data.duration !== "undefined") {
        return response.data.duration;
      }
      return response.data;
    },
  },
};
